export const perPagePaginationArray = [25, 50, 100];

export interface FilterValue {
  skip?: number;
  page?: number;
  take?: number;
  sortModel?: any[];
  search?: string;
  showNonZero?: boolean;
  sortBy?: string;
  customFilter?: any;
}

export const defaultFilterValue: FilterValue = {
  skip: 0,
  page: 0,
  take: perPagePaginationArray[0],
  sortModel: [],
  search: "",
  showNonZero: false,
  sortBy: "amount",
  customFilter: {},
};

export const createCommonFilter = (): FilterValue => ({
  ...defaultFilterValue,
});

/**
 * Define all filter keys in one place
 */
export const filterKeys = [
  "portfolio",
  "portfolioGroup",
  "importManager",
  "bankStatement",
  "client",
  "report",
  "tradeBook",
  "family",
  "compliance",
  "lead",
  "branch",
  "clientAccess",
  "clientFamily",
  "familyClient",
  "portfolioAccess",
  "branchPortfolio",
  "branchClient",
  "employeePortfolioAccess",
  "familyAccess",
  "employeeAccess",
  "employeeFamilyAccess",
  "employeeClientAccess",
  "familyPortfolio",
  "holdingSummary",
  "avlCashBalance",
  "portfolioHolding",
  "portfolioHoldingTransaction",
  "portfolioGroupHolding",
  "clientHolding",
  "familyHolding",
  "branchHolding",
  "employeeHolding",
  "portfolioHoldingCasheEquivalent",
  "portfolioHoldingEquity",
  "holdingDetails",
  "feePlans",
  "portfolioImportManager",
  "portfolioTradeBook",
  "feeCalculation",
  "proformaInvoice",
  "portfolioMapping",
  "invoice",
  "feeCollection",
  "feePlanPortfolioMapping",
  "walletHistory",
  "walletFullHistory",
  "reconManager",
  "mutualFund",
  "portfolioMutualFunds",
  "incomeExpense",
  "bankLedger",
  "portfolioBankLedger",
  "portfolioInterest",
  "portfolioCashEntry",
  "customBroker",
  "reportScheduler",
  "portfolioInvoice",
  "portfolioProforma",
  "portfolioCalculation",
  "portfolioIncomeExpense",
  "paymentLink",
  "equityBasketOrderManagerPortfolio",
  "insights",
  "portfolioHoldingsTable",
  "portfolioFamilyAccess",
  "familyPortfolioAccess",
  "familyAdminAccess",
  "revenueMandate",
  "mandatePresentation",
  "mandatePresentationTransaction",
  "privateEquity",
  "identifiers",
  "corporateAction",
  "anchorTransaction",
  "privateEquityList",
  "portfolioPrivateEquityList",
  "partner",
  "partnerClient",
  "partnerInvoice",
  "FDList",
  "portfolioFDList",
  "subscribedPortfolio",
  "FDPayoutList",
  "portfolioFDPayoutList",
  "AIF",
  "portfolioAIFList",
  "aif",
  "clientUploadProof",
  "subscribedHistory",
  "subscribedPaymentHistory",
  "partnerPortfolioAccess",
  "coupon",
  "totalOrders",
  "modelPortfolioOrderManager",
  "commissionManager",
  "portfolioCommission",
  "partnerCommission",
  "branchAdmin",
  "positions",
  "portfolioFeeCollection",
  "automation",
  // "tag",
  "mfOrderBatches",
] as const;

/**
 * Strongly-typed keys
 */
export type FilterKey = (typeof filterKeys)[number];

/**
 * Type-safe CommonFilterState
 */
export type CommonFilterState = Record<FilterKey, FilterValue>;

/**
 * Generate initial state dynamically
 */
export const initialCommonFilterState: CommonFilterState = filterKeys.reduce(
  (acc, key) => {
    acc[key] = createCommonFilter();
    return acc;
  },
  {} as CommonFilterState,
);
